require('./RASustainabilityQuestion.scss');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const {
    SUSTAINABILITY_QUESTION_400,
    SUSTAINABILITY_QUESTION_401,
} = require('utilities/tagging');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const OKModal = require('components/commons/OKModal/OKModal');

// @components
const { RadioButton } = require('commonsComponents/radioButton');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @constants
const {
    SUSTAINABILITY_ANSWER_NEUTRAL,
    SUSTAINABILITY_ANSWER_INTERMEDIATE,
    SUSTAINABILITY_ANSWER_ADVANCED,
    SUSTAINABILITY_ANSWER_ARRAY,
} = require('../../raConstants/index');

class RASustainabilityQuestion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            currentTagging: '',
        };
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleTooltipHover = this.handleTooltipHover.bind(this);
        this.buildHeadingText = this.buildBoxHeadingText.bind(this);
        this.buildQuestionDescription = this.buildQuestionDescription.bind(
            this,
        );
    }

    componentDidMount() {
        const { immSuitabilityTest } = this.props;
        const currentSustainabilityQuestionId = immSuitabilityTest.get(
            'currentSustainabilityQuestionId',
        );
        const currentTag =
            currentSustainabilityQuestionId === '400'
                ? SUSTAINABILITY_QUESTION_400
                : SUSTAINABILITY_QUESTION_401;
        this.setState({ currentTagging: currentTag });
    }

    handleToggleModal(event) {
        this.setState({
            showModal: !this.state.showModal,
        });

        if (event === 'close') {
            taggingEventHandled(
                this.state.currentTagging,
                'answer11_modal_close',
            );
        } else if (event === 'button') {
            taggingEventHandled(
                this.state.currentTagging,
                'answer11_modal_button',
            );
        } else {
            taggingEventHandled(
                this.state.currentTagging,
                'answer11_modal_open',
            );
        }
    }
    handleTooltipHover() {
        taggingEventHandled(this.state.currentTagging, 'answer11_tooltip');
    }

    buildDescriptionChoiceBox() {
        const { sustainabilityAnswer } = this.props;
        switch (SUSTAINABILITY_ANSWER_ARRAY[sustainabilityAnswer]) {
            case SUSTAINABILITY_ANSWER_NEUTRAL:
                return (
                    <div className="ra-sustainability-question__description-choice ra-sustainability-question__description-choice-neutral">
                        <FormattedText value="raSuitabilityTest-sustainabilityQuestion_choiceNeutralDescription" />
                    </div>
                );
            case SUSTAINABILITY_ANSWER_INTERMEDIATE:
                return (
                    <div className="ra-sustainability-question__description-choice ra-sustainability-question__description-choice-intermediate">
                        <FormattedText value="raSuitabilityTest-sustainabilityQuestion_choiceIntermediateDescription" />
                    </div>
                );

            case SUSTAINABILITY_ANSWER_ADVANCED:
                return (
                    <div className="ra-sustainability-question__description-choice ra-sustainability-question__description-choice-advanced">
                        <FormattedText value="raSuitabilityTest-sustainabilityQuestion_choiceAdvancedDescription" />
                    </div>
                );
            default:
                return null;
        }
    }

    buildBoxClasses(boxType) {
        const { immSuitabilityTest, sustainabilityAnswer } = this.props;
        const currentSustainabilityQuestionId = immSuitabilityTest.get(
            'currentSustainabilityQuestionId',
        );
        const isCurrentSustainabilityQuestionId400 =
            currentSustainabilityQuestionId === '400';
        const boxClass = isCurrentSustainabilityQuestionId400
            ? 'ra-sustainability-question__box'
            : 'ra-sustainability-question__box-short';
        const boxTypeClass = `ra-sustainability-question__box-${
            currentSustainabilityQuestionId === '400' ? boxType : 'neutral'
        }`;
        const boxClassChosen =
            boxType === SUSTAINABILITY_ANSWER_ARRAY[sustainabilityAnswer]
                ? `ra-sustainability-question__box-${
                      isCurrentSustainabilityQuestionId400 ? boxType : 'neutral'
                  }-highlighted`
                : null;
        return `${boxClass} ${boxTypeClass} ${boxClassChosen}`;
    }

    buildModalContent() {
        return (
            <div>
                <div className="ra-sustainability-question__modal-title">
                    <FormattedText value="raSuitabilityTest-sustainabilityQuestion_modalTitle" />
                </div>
                <div className="ra-sustainability-question__modal-content">
                    <p>
                        <FormattedText value="raSuitabilityTest-sustainabilityQuestion_modalContent1" />
                    </p>
                    <p>
                        <FormattedText value="raSuitabilityTest-sustainabilityQuestion_modalContent2" />
                    </p>
                </div>
            </div>
        );
    }

    buildBoxHeadingText(isCurrentSustainabilityQuestionId400) {
        return isCurrentSustainabilityQuestionId400 ? (
            <div className="ra-sustainability-question__box-heading-text">
                <FormattedText value="raSuitabilityTest-sustainabilityQuestion_subTitle" />
            </div>
        ) : null;
    }

    buildQuestionDescription(isCurrentSustainabilityQuestionId400) {
        return isCurrentSustainabilityQuestionId400 ? (
            <div className="ra-sustainability-question__description">
                <FormattedText value="raSuitabilityTest-sustainabilityQuestion_description" />
            </div>
        ) : null;
    }

    is401QuestionAnsweredWith(answerId) {
        const { immSuitabilityTest } = this.props;
        return immSuitabilityTest.getIn(['answers', '401']) === answerId;
    }

    render() {
        const { immSuitabilityTest, sustainabilityQuestionTitle } = this.props;
        const currentSustainabilityQuestionId = immSuitabilityTest.get(
            'currentSustainabilityQuestionId',
        );
        const isCurrentSustainabilityQuestionId400 =
            currentSustainabilityQuestionId === '400';
        const immQuestion = immSuitabilityTest.getIn([
            'questions',
            currentSustainabilityQuestionId,
        ]);
        const immAnswers = !!immQuestion && immQuestion.get('answers');
        const immNeutralAnswer =
            !!immAnswers &&
            immAnswers.find(answer => answer.get('id') === 'answer1');
        const neutralAnswerDescription =
            !!immNeutralAnswer && immNeutralAnswer.getIn(['label', 'title']);

        const immIntermediateAnswer =
            !!immAnswers &&
            immAnswers.find(answer => answer.get('id') === 'answer2');
        const intermediateAnswerDescription =
            !!immIntermediateAnswer &&
            immIntermediateAnswer.getIn(['label', 'title']);

        const immAdvancedlAnswer =
            !!immAnswers &&
            immAnswers.find(answer => answer.get('id') === 'answer3');
        const AdvancedAnswerDescription =
            !!immAdvancedlAnswer &&
            immAdvancedlAnswer.getIn(['label', 'title']);

        const electionBox = this.buildDescriptionChoiceBox();

        const boxHeadingText = this.buildBoxHeadingText(
            isCurrentSustainabilityQuestionId400,
        );

        const questionDescription = this.buildQuestionDescription(
            isCurrentSustainabilityQuestionId400,
        );

        return (
            <div className="ra-sustainability-question__container">
                <OKModal
                    content={this.buildModalContent()}
                    descriptionAlignment="center"
                    footerType="navigation"
                    isOpen={this.state.showModal}
                    onCloseCallback={() => this.handleToggleModal('close')}
                    onPrimaryButtonClick={() =>
                        this.handleToggleModal('button')
                    }
                    primaryButtonText="raSuitabilityTest-sustainabilityQuestion_modalButton"
                    shouldCloseOnOverlayClick={false}
                    titleAlignment="center"
                />
                <div className="ra-sustainability-question__header">
                    <div className="ra-sustainability-question__title">
                        {sustainabilityQuestionTitle}
                        <div
                            className="ra-sustainability-question__tooltip"
                            onClick={this.handleToggleModal}
                            onMouseEnter={this.handleTooltipHover}
                        >
                            <div className="ra-sustainability-question__tooltip-icon" />
                        </div>
                    </div>
                    {questionDescription}
                </div>
                <div className="ra-sustainability-question__box-section">
                    {boxHeadingText}
                    <div className="ra-sustainability-question__box-container">
                        <div
                            className={this.buildBoxClasses('neutral')}
                            onClick={() => {
                                taggingEventHandled(
                                    this.state.currentTagging,
                                    'answer11_1',
                                );
                                this.props.setSustainabilityAnswer('answer1');
                            }}
                        >
                            {isCurrentSustainabilityQuestionId400 ? (
                                <div className="ra-sustainability-question__box-title">
                                    <FormattedText value="raSuitabilityTest-sustainabilityQuestion_boxNeutralTitle" />
                                </div>
                            ) : (
                                <div>
                                    <div className="ra-sustainability-question__box-title-icon_container">
                                        <RadioButton
                                            className="ra-sustainability-question__box-title-radio-button"
                                            isChecked={this.is401QuestionAnsweredWith(
                                                'answer1',
                                            )}
                                            value="answer1"
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="ra-sustainability-question__box-description">
                                {neutralAnswerDescription}
                            </div>
                        </div>
                        <div
                            className={this.buildBoxClasses('intermediate')}
                            onClick={() => {
                                taggingEventHandled(
                                    this.state.currentTagging,
                                    'answer11_2',
                                );
                                this.props.setSustainabilityAnswer('answer2');
                            }}
                        >
                            {isCurrentSustainabilityQuestionId400 ? (
                                <div className="ra-sustainability-question__box-title">
                                    <FormattedText value="raSuitabilityTest-sustainabilityQuestion_boxIntermediateTitle" />
                                </div>
                            ) : (
                                <div className="ra-sustainability-question__box-title-icon_container">
                                    <i className="ra-sustainability-question__box-title-icon icon" />
                                    <RadioButton
                                        className="ra-sustainability-question__box-title-radio-button"
                                        isChecked={this.is401QuestionAnsweredWith(
                                            'answer2',
                                        )}
                                        value="answer2"
                                    />
                                </div>
                            )}
                            <div className="ra-sustainability-question__box-description">
                                {intermediateAnswerDescription}
                            </div>
                        </div>
                        <div
                            className={this.buildBoxClasses('advanced')}
                            onClick={() => {
                                taggingEventHandled(
                                    this.state.currentTagging,
                                    'answer11_3',
                                );
                                this.props.setSustainabilityAnswer('answer3');
                            }}
                        >
                            {isCurrentSustainabilityQuestionId400 ? (
                                <div className="ra-sustainability-question__box-title">
                                    <i className="ra-sustainability-question__box-title-icon icon icon-esg" />
                                    <FormattedText value="raSuitabilityTest-sustainabilityQuestion_boxAdvancedTitle" />
                                </div>
                            ) : (
                                <div className="ra-sustainability-question__box-title-icon_container">
                                    <i className="ra-sustainability-question__box-title-icon icon" />
                                    <i className="ra-sustainability-question__box-title-icon icon" />
                                    <RadioButton
                                        className="ra-sustainability-question__box-title-radio-button"
                                        isChecked={this.is401QuestionAnsweredWith(
                                            'answer3',
                                        )}
                                        value="answer3"
                                    />
                                </div>
                            )}

                            <div className="ra-sustainability-question__box-description">
                                {AdvancedAnswerDescription}
                            </div>
                        </div>
                    </div>
                </div>
                {isCurrentSustainabilityQuestionId400 && electionBox}
            </div>
        );
    }
}

RASustainabilityQuestion.propTypes = {
    setSustainabilityAnswer: PropTypes.func,
    immSuitabilityTest: PropTypes.object,
    sustainabilityAnswer: PropTypes.string,
    sustainabilityQuestionTitle: PropTypes.string,
    stepNumber: PropTypes.number,
};

module.exports = RASustainabilityQuestion;
